export default {
	unlockedClientsOverviewHeader: 'Přehled odemčených klientů',
	fullyUnlockedClient: 'Označuje odemčeného klienta',
	unlockedForDayClient: 'Označuje odemčeného klienta, který se následující den uzamkne',
	lockedClient: 'Označuje uzamčeného klienta',
	unlockedClientsTableRecords1YearOldOnly: 'Je možné vyhledat pouze záznamy, které nejsou starší než 1 rok.',
	client: 'Klient',
	mobileApplication: 'Mobilní aplikace',
	sms: 'SMS',
	webcam: 'Webkamera',
	pageTitle: 'Odemčení klienti',
	plannedActivity: 'Plánovaná aktivita',
	bankId: 'BankID',
	eDoklady: 'eDoklady',
	surname: 'Příjmení',
	firstName: 'Jméno',
	businessName: 'Název',
	personIn: 'Rodné číslo',
	businessIn: 'IČO',
	birthDate: 'Datum narození',
	unlockedFrom: 'Datum odemčení od',
	unlockedTo: 'Datum odemčení do',
	extendedFrom: 'Prodlouženo od',
	extendedTo: 'Prodlouženo do',
	unlockChannels: 'Způsob odemčení',
	unlockedFromTableHeader: 'Odemčeno od',
	unlockedToTableHeader: 'Odemčeno do',
};
